import { useState, useEffect, useMemo } from 'react';

type Breakpoint = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

const breakpoints = {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
};

const useCurrentMediaQuery = (): Breakpoint => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const currentBreakPoint = useMemo(() => {
        if (windowWidth >= breakpoints.xl) {
            return 'xl';
        }
        if (windowWidth >= breakpoints.lg) {
            return 'lg';
        }
        if (windowWidth >= breakpoints.md) {
            return 'md';
        }
        if (windowWidth >= breakpoints.sm) {
            return 'sm';
        }
        return 'xs';
    }, [windowWidth]);

    return currentBreakPoint;
};

export default useCurrentMediaQuery;
